module.exports = __webpack_public_path__ + "media/images/profil-bb72da1914421f46ca244f63f980e9e4.svg";